import { PhaseStepTypeBase } from './base/phase-step-type-base';

export class PhaseStepType extends PhaseStepTypeBase { }